import {
  CreateTask,
  PatchScheduleTask,
  PatchTask,
  Task,
} from "@coworker/apprestructured/src/task-management/types/Task";
import { httpClient } from "@coworker/http-client";
import { Log } from "../types/Log";
import { Comment } from "../types/Comment";
import { SignedUpload } from "@coworker/apprestructured/src/task-management/types/Upload";
import { Schedule } from "../types/Schedule";

export async function createTask(createTask: CreateTask) {
  return httpClient.tasks.post<Task>("/tasks-v2", { body: createTask });
}

async function getTasks(ids: string[]) {
  return httpClient.tasks.get<Task[]>(`/tasks-v2/${ids.join(",")}`);
}

export async function getTask(id: string) {
  const tasks = await getTasks([id]);
  return tasks[0];
}

export async function updateTask(id: string, patchTask: PatchTask) {
  return httpClient.tasks.patch<Task>(`/tasks-v2/${id}`, { body: patchTask });
}

export async function updatePendingTasksInSchedule(
  scheduleId: string,
  patchScheduleTask: PatchScheduleTask
) {
  await httpClient.tasks.patch("/tasks-v2", {
    params: { schedule_id: scheduleId, state: "pending" },
    body: patchScheduleTask,
  });
}

export async function getTaskLogs(id: string) {
  return httpClient.tasks.get<Log[]>(`/tasks-v2/${id}/logs`);
}

export async function getTaskComments(id: string) {
  return httpClient.tasks.get<Comment[]>(`/tasks-v2/${id}/comments`);
}

export async function getTaskImages(taskId: string) {
  return httpClient.tasks.get<SignedUpload[]>(`/tasks-v2/${taskId}/images`);
}

export async function getTaskCommentsImages(taskId: string) {
  return httpClient.tasks.get<SignedUpload[]>(
    `/tasks-v2/${taskId}/comments/images`
  );
}

export async function getTaskFiles(taskId: string) {
  return httpClient.tasks.get<SignedUpload[]>(`/tasks-v2/${taskId}/files`);
}

export async function getTaskSchedule(taskId: string) {
  return httpClient.tasks.get<Schedule>(`/tasks-v2/${taskId}/schedule`);
}
